import { createAction, props } from '@ngrx/store';
import { ICheckCardStatusRequest, ICheckCardStatusResponse } from '../models/check-card-status.model';

export const loadCheckCardStatus = createAction(
  '[CheckCardStatus] Load CheckCardStatus',
  props<{ businessId: string; request: ICheckCardStatusRequest }>()
);

export const loadCheckCardStatusSuccess = createAction(
  '[CheckCardStatus] Load CheckCardStatus Success',
  props<{ response: ICheckCardStatusResponse }>()
);

export const loadCheckCardStatusFailure = createAction('[CheckCardStatus] Load CheckCardStatus Failure', props<{ error: Error | any }>());
